import { useWeb3React } from '@web3-react/core';
import { Fragment, useContext } from 'react';
import Detail from '../../../../../components/Detail';
import { config } from '../../../../../config/config';
import appContext from '../../../../../context/app/appContext';
import CreateASpoolContext from '../../../../../context/createASpool/createASpoolContext';
import { formatAccount, formatPercentages } from '../../../../../helpers/formats';
import { AddressZero } from '@ethersproject/constants';
import CopyPopUp from '../../../../../components/CopyPopUp';
import InfoPopUp from '../../../../../components/InfoPopUp';
import { getRiskScore, mapRiskToRange } from '../../../../../helpers/sdkHelper';

const CreateSpoolDetail = () => {
    const { riskModels, chainStrategies, chainRiskModels } = useContext(appContext);

    const { spoolFee, riskTolerance, baseApy, selectedRiskModel, selectedStrategies } =
        useContext(CreateASpoolContext);

    const { account } = useWeb3React();

    const riskModelFee =
        riskModels && selectedRiskModel ? riskModels[selectedRiskModel] : 0;

    const totalPerformanceFee = spoolFee + riskModelFee + config.daoPerformanceFees;

    return (
        <div className='details'>
            <Detail
                className='creator-address'
                title='Spool Creator Address'
                value={
                    <>
                        <span>{formatAccount(account || AddressZero)}</span>
                        <CopyPopUp text={account || AddressZero} />
                    </>
                }
            />
            <Detail
                className='risk-model'
                title='Risk Model'
                value={chainRiskModels[selectedRiskModel!]?.name ?? 'Risk Model'}
            />
            <Detail
                className='strategies'
                title='Strategies'
                value={selectedStrategies.map((strategy, index) => (
                    <Fragment key={index}>
                        {<span>{chainStrategies[strategy]?.name ?? 'Strategy'}</span>}
                    </Fragment>
                ))}
            />
            <Detail title={`Spool Creator  Performance Fee`} value={`${spoolFee}%`} />
            <Detail
                title={`Risk Model  Performance Fee`}
                value={`${riskModelFee ?? '0.00'}%`}
            />
            <Detail
                className='stablecoin-apy'
                title='Stablecoin APY'
                value={`${formatPercentages(baseApy || 0)}%`}
            />
            <Detail
                title={`DAO Performance Fee`}
                value={`${formatPercentages(config.daoPerformanceFees)}%`}
            />
            <Detail
                className='risk-tolerance'
                title='Risk Appetite'
                value={
                    <>
                        <span>{getRiskScore(riskTolerance)}</span> (
                        {mapRiskToRange(riskTolerance)})
                    </>
                }
            />
            <Detail
                className='adjusted-apy'
                title={
                    <>
                        <span>Adjusted APY After Performance Fees</span>
                        <InfoPopUp>
                            <div>
                                Performance Fees are taken only after the user has
                                withdrawn and realized yield.
                            </div>
                            <div className='mt'>
                                Total Performance Fees for this Spool are{' '}
                                {formatPercentages(totalPerformanceFee || 0)}% (
                                {formatPercentages(
                                    (baseApy * totalPerformanceFee) / 100
                                ) || 0}
                                % of the Gross APY of {formatPercentages(baseApy || 0)}% )
                            </div>
                            <div className='mt'>
                                {formatPercentages(baseApy || 0)}% APY -{' '}
                                {formatPercentages(totalPerformanceFee || 0)}% Fees ={' '}
                                {formatPercentages(
                                    (baseApy * (100 - totalPerformanceFee)) / 100
                                )}
                                % Adjusted APY After Fees
                            </div>
                        </InfoPopUp>
                    </>
                }
                value={`${formatPercentages(
                    (baseApy * (100 - totalPerformanceFee)) / 100
                )}%`}
            />
            <Detail
                className='total-performance-fee'
                title={
                    <>
                        <span>Total Performance Fee</span>
                        <InfoPopUp>
                            <span>
                                Fees are based on the user’s profits earned through the
                                Spool and are distributed on withdrawal.
                            </span>
                            <div className='mt'>
                                <strong>Creator Fee: </strong>
                                {formatPercentages(spoolFee || 0)}%
                            </div>
                            <div>
                                <strong>Risk Model Fee: </strong>
                                {riskModelFee ?? '0.00'}%
                            </div>
                            <div>
                                <strong>DAO’s Fee: </strong>
                                {formatPercentages(config.daoPerformanceFees)}%
                            </div>
                        </InfoPopUp>
                    </>
                }
                value={`${formatPercentages(totalPerformanceFee || 0)}%`}
            />
        </div>
    );
};

export default CreateSpoolDetail;
